import clsx from 'clsx';
import React from 'react';

export interface SvgIconProps {
  size: string;
  offsetUp?: boolean;
  className?: string;
}

const SvgIcon = (props: SvgIconProps & { viewBox: [number, number]; d: string }) => (
  <SvgComplexIcon
    size={props.size}
    offsetUp={props.offsetUp}
    className={props.className}
    viewBox={[0, 0, props.viewBox[0], props.viewBox[1]]}
    d={props.d}
  />
);

export const SvgComplexIcon = (props: SvgIconProps & { viewBox: [number, number, number, number]; d: string }) => (
  <svg
    viewBox={`${props.viewBox[0]} ${props.viewBox[1]} ${props.viewBox[2]} ${props.viewBox[3]}`}
    height={props.size}
    width={props.size}
    className={clsx('tw-relative', props.offsetUp ? '-tw-top-[0.08em]' : null, props.className)}
  >
    <path fill="currentColor" d={props.d} />
  </svg>
);

export default SvgIcon;
